var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"pagination_list-item"},[_c(_vm.show_link_tag ? 'a' : 'span',_vm._b({tag:"component",domProps:{"innerHTML":_vm._s(_vm.text)},on:{"click":function($event){$event.preventDefault();return _vm.emitClick.apply(null, arguments)}}},'component',_vm.link_data,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }